import {GridWidgetFilter} from './grid-widget-filter';
import {DataField} from '../data-field';

export enum DisableFilterOption {
  both,
  advancedOnly,
  simpleOnly
}
export abstract class GridWidgetDataField extends DataField {
  //used for sorting the select boxes that the DataFields show up in.
  //IF it is filled in.
  sortKey: number | undefined;

  //When this field is set to true, the field will be the default filter to show up.
  //I don't recommend setting more than one of these to true or you will get unexpected
  //results.
  defaultFilterOption = false;

  //This is placeholder text that will populate an empty field to help the user know what to enter. e.g. 'Enter Your Mother's Name'
  placeholderText: string;

  validationRules: any = {};

  //When left undefined, this will not disable the filter capability for this field.
  //new feature in GridWidget 2
  filterDisabled: DisableFilterOption;

  //This is used for determine whether to export the field to a file or not.
  fieldExportDisabled = false;

  /**
   * The sort order is the order they will show up in the drop downs.
   * @param id 0 similar to an html id in that it needs to be unique for the page you are using it for. Should contain
   * a-z 0-9 and -.  this may show up in the DOM.
   * @param objectLookup
   * @param sortOrder
   */
  constructor(id: string, objectLookup: string | ((Object) => any), title: string, sortOrder?: number) {
    super(id, objectLookup, title);
    if (this.id == null || this.id.startsWith('+') || this.id.startsWith('-')) {
      throw 'there must be an id, and it can not start with  + or -';
    }
    this.sortKey = sortOrder;
  }

  toString(): string {
    return 'GridWidgetDataField: ' + this.id;
  }

  setPlaceholderText(placeholderText: string): void {
    this.placeholderText = placeholderText;
  }

  setDefaultFilterOption(): void {
    this.defaultFilterOption = true;
  }

  //TODO write unit tests for this.
  //Make sure to especially test with numberOfAvailableFilters
  disableFiltering(option: DisableFilterOption = DisableFilterOption.both): void {
    this.filterDisabled = option;
  }

  /**
   * Calling this function will exclude this field from exporting to the csv file.
   */
  disableExport(): void {
    this.fieldExportDisabled = true;
  }

  /**
   * During the filter process, the Filter Task creates a filter instance for each of the available
   * fields to be 'quick filters'.  These are separate instances from the advanced filter instances
   * that get created when the user presses the + button.
   */
  abstract getFilterInstance(): GridWidgetFilter;

  /**
   * Each individual field should make a type for the rules object that gets passed in.
   */
  setValidationRules(rules: any): void {
    throw 'validation rules have not been implemented for this field type';
  }
}
